"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WordLikeParagraphGroups = exports.WHOLE_PARAGRAPH_ANCHOR_LABEL = exports.TABLE_NOT_DRAWN_LABEL = exports.PAGE_REVISIONS_LEGEND_LABEL = exports.OPEN_IN_CHAT_TITLE = exports.GROUP_NOT_DRAWN_LABEL = exports.APPLY_PARAGRAPH_LABEL = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _OoxmlContent = _interopRequireDefault(require("@common/components/remedy/OoxmlContent"));
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _revisionStyle = require("@common/components/remedy/revision-style");
var _revisionTitle = require("@common/components/remedy/revision-title");
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _redlinePayload = require("@common/utils/redline/wire/redline-payload");
var _redlinePlacement = require("@common/utils/redline/wire/redline-placement");
var _utils = require("@design/lib/utils");
var _checkbox = require("@design/ui/checkbox");
var _AppliedRedlineDocumentation = require("../../redline/AppliedRedlineDocumentation");
var _RevisionLegend = _interopRequireDefault(require("../../redline/RevisionLegend"));
var _SectionBoundary = require("../../SectionBoundary");
var _AnalyticsContext = require("../../../context/AnalyticsContext");
var _ProposalEditsContext = require("../../../context/ProposalEditsContext");
var _useProposalEngineEnabled = require("../../../hooks/use-proposal-engine-enabled");
var _useResetProposalEdit = require("../../../hooks/use-reset-proposal-edit");
var _anchorLog = require("../../../utils/anchor/anchor-log");
var _anchoredProposal = require("../../../utils/anchor/proposal/anchored-proposal");
var _redlineRowRemoved = require("../../../utils/redline-row-removed");
var _cardKinds = require("../proposal-card/card-kinds");
var _LinksNeedingAddressIndicator = require("../proposal-card/LinksNeedingAddressIndicator");
var _ProposalCardActions = require("../proposal-card/ProposalCardActions");
var _RemedyPartSupersededIndicator = require("../proposal-card/RemedyPartSupersededIndicator");
var _RevertedInDocumentIndicator = require("../proposal-card/RevertedInDocumentIndicator");
var _WrittenBackIndicator = require("../proposal-card/WrittenBackIndicator");
var _CommentTextEditor = require("../proposal-edit/CommentTextEditor");
var _newParagraphTextCard = require("../proposal-edit/new-paragraph-text-card");
var _ProposalEditorOnPage = require("../../redline/ProposalEditorOnPage");
var _DrawnByRender = require("./DrawnByRender");
var _pageRevisions = require("./page-revisions");
var _tableGroupPackage = require("./table-group-package");
var _paragraphGroups = require("./paragraph-groups");
var _useFailedCardsNotShown = require("./use-failed-cards-not-shown");
var _trackerTypes = require("./tracker-types");
var _wordLikeParagraph = require("./word-like-paragraph");
var _textExcerpt = require("../../../utils/text-excerpt");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import { useCardDetails } from "../proposal-card/CardDetailsContext";
// import { DETAILS_BUTTON_LABEL } from "../proposal-card/ProposalCardActions";
var TABLE_PAGE_TYPOGRAPHY = _objectSpread(_objectSpread({}, _AppliedRedlineDocumentation.INHERITED_TYPOGRAPHY), {}, {
  wordBreak: "normal",
  overflowWrap: "normal"
});
var DRAWER_COMPOSITION_STAMPED_AT = new Date().toISOString();
var NO_TABLE_CARD_COLORS = new Map();
var GROUP_NOT_DRAWN_LABEL = exports.GROUP_NOT_DRAWN_LABEL = "These changes could not be drawn, not applied.";
var TABLE_NOT_DRAWN_LABEL = exports.TABLE_NOT_DRAWN_LABEL = "This table could not be drawn, not applied.";
var asError = function asError(error) {
  return error instanceof Error ? error : new Error(String(error));
};
function commentedCellsOf(group) {
  return (0, _wordLikeParagraph.commentMembersOf)(group).flatMap(function (_ref) {
    var member = _ref.member;
    var content = member.card.content;
    if (content.kind !== "comment" || content.bookmarks[0] === undefined) return [];
    return [{
      bookmark: content.bookmarks[0],
      actionId: member.action.id,
      mark: {
        commentId: member.action.cardNumber,
        anchorText: content.anchorText
      }
    }];
  });
}
function composedTableWithCommentMarks(composedTable, commentedCells, onMarkFailure) {
  var marksByBookmark = new Map(commentedCells.map(function (_ref2) {
    var bookmark = _ref2.bookmark,
      mark = _ref2.mark;
    return [bookmark, mark];
  }));
  try {
    return (0, _tableGroupPackage.withCommentedCells)(composedTable, marksByBookmark, DRAWER_COMPOSITION_STAMPED_AT);
  } catch (_unused) {
    return commentedCells.reduce(function (table, _ref3) {
      var bookmark = _ref3.bookmark,
        actionId = _ref3.actionId,
        mark = _ref3.mark;
      try {
        return (0, _tableGroupPackage.withCommentedCells)(table, new Map([[bookmark, mark]]), DRAWER_COMPOSITION_STAMPED_AT);
      } catch (error) {
        onMarkFailure(actionId, error);
        return table;
      }
    }, composedTable);
  }
}
function groupDrawKeysOf(group, tablePackagesByGroup) {
  var tablePackage = tablePackagesByGroup.get(group.kind === "table" ? group.bookmark : (0, _pageRevisions.tableGroupKeyOf)(group.bookmark));
  var memberSignature = (0, _paragraphGroups.allMembersOf)(group).map(function (member) {
    return [member.action.id, member.action.isApplied, member.card.textRedlineBeforeEdit === null, member.card.textBeforeEdit === null].join(":");
  }).join("|");
  return [group.baseText, JSON.stringify(group.pageRevisions), tablePackage, memberSignature, group.conflict === null];
}
var GroupNotDrawn = function GroupNotDrawn(_ref4) {
  var bookmark = _ref4.bookmark;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1.5 p-1.5 rounded border border-[#FDE68A] bg-[#FFFDF5] text-[11px] text-[#92400E]",
    "data-word-like-group-not-drawn": bookmark,
    "data-sentry-component": "GroupNotDrawn",
    "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
      width: 13,
      height: 13,
      className: "flex-shrink-0 text-[#F59E0B]",
      "data-sentry-element": "WarningIcon",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: GROUP_NOT_DRAWN_LABEL
    })]
  });
};
var ComposedTablePage = /*#__PURE__*/_react.default.memo(function ComposedTablePage(_ref5) {
  var composedTable = _ref5.composedTable,
    cardColorByAuthor = _ref5.cardColorByAuthor;
  var pageAuthorColorOf = (0, _RedlineAuthorColorsContext.useRedlineAuthorColor)();
  var authorColorOf = (0, _react.useMemo)(function () {
    return function (author) {
      var _cardColorByAuthor$ge;
      return (_cardColorByAuthor$ge = cardColorByAuthor.get(author)) !== null && _cardColorByAuthor$ge !== void 0 ? _cardColorByAuthor$ge : pageAuthorColorOf(author);
    };
  }, [cardColorByAuthor, pageAuthorColorOf]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RevisionLegend.default, {
      ooxml: composedTable,
      alwaysListedAuthors: [],
      authorColorOf: authorColorOf
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OoxmlContent.default, {
      ooxml: composedTable,
      style: TABLE_PAGE_TYPOGRAPHY,
      getHtmlTitleProp: _revisionTitle.revisionTitleOf,
      markCommentRanges: true,
      authorColorOf: authorColorOf
    })]
  });
});
var WHOLE_PARAGRAPH_ANCHOR_LABEL = exports.WHOLE_PARAGRAPH_ANCHOR_LABEL = "whole paragraph";
var OPEN_IN_CHAT_TITLE = exports.OPEN_IN_CHAT_TITLE = "Open in chat";
var APPLY_PARAGRAPH_LABEL = exports.APPLY_PARAGRAPH_LABEL = "Apply";
var PAGE_REVISIONS_LEGEND_LABEL = exports.PAGE_REVISIONS_LEGEND_LABEL = "Tracked changes in the document";
var COMMENT_EXCERPT_CHARACTERS = 160;
var ANCHOR_EXCERPT_CHARACTERS = 40;
var HOVER_DELAY_MS = 150;
var iconButtonClass = "flex-shrink-0 p-0.5 hover:bg-[#E5E2DD] rounded transition-colors bg-transparent border-none cursor-default disabled:opacity-50";
var iconClass = "text-[#686766] cursor-pointer";
var headerButtonClass = "flex-shrink-0 h-[20px] px-2 rounded text-[10px] border cursor-pointer whitespace-nowrap";
var deletedTextClass = "text-[#A81E36] line-through decoration-[#A81E36]";
var activateOnEnterOrSpace = function activateOnEnterOrSpace(activate) {
  return function (event) {
    if (event.target !== event.currentTarget) return;
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    activate();
  };
};
var appliedStatusLabelOf = function appliedStatusLabelOf(action) {
  if (action.supersededBy) return "Superseded by ".concat(action.supersededBy);
  if (action.partSupersededBy) return (0, _RemedyPartSupersededIndicator.partSupersededLabelOf)(action.partSupersededBy);
  if (action.writtenBack) return _WrittenBackIndicator.WRITTEN_BACK_SHORT_LABEL;
  if (action.partlyRevertedInDocument) return _RevertedInDocumentIndicator.PARTLY_REVERTED_IN_DOCUMENT_LABEL;
  return "Applied";
};
function writtenBackReasonOf(action) {
  if (!action.writtenBack) return undefined;
  return action.failureReason;
}
function quotedWordsOfCommentOrWholeParagraph(member) {
  var content = member.card.content;
  if (content.kind !== "comment" || content.anchorText === null) return WHOLE_PARAGRAPH_ANCHOR_LABEL;
  return "\u201C".concat((0, _textExcerpt.excerptOf)(content.anchorText, ANCHOR_EXCERPT_CHARACTERS), "\u201D");
}
function anchorLabelOf(group, member) {
  if (group.kind === "table" && member.card.content.kind === "comment") {
    var _member$card$content$;
    var cellText = (_member$card$content$ = member.card.content.anchorText) !== null && _member$card$content$ !== void 0 ? _member$card$content$ : member.card.content.paragraphText;
    return cellText === null ? "this table" : "\u201C".concat((0, _textExcerpt.excerptOf)(cellText, ANCHOR_EXCERPT_CHARACTERS), "\u201D");
  }
  if (member.wordSpan === null) return quotedWordsOfCommentOrWholeParagraph(member);
  var anchorText = group.baseText.slice(group.baseUnits[member.wordSpan.startWordIndex].startOffset, group.baseUnits[member.wordSpan.endWordIndex - 1].endOffset);
  return "\u201C".concat((0, _textExcerpt.excerptOf)(anchorText, ANCHOR_EXCERPT_CHARACTERS), "\u201D");
}
function newParagraphTextsOf(member) {
  return member.card.content.kind === "paragraph" ? member.card.content.newParagraphTexts : [];
}
function editableTextCardOf(card, author) {
  if (card.content.kind === "paragraph") return (0, _newParagraphTextCard.textCardOfNewParagraphCard)(card.content, author);
  return (0, _trackerTypes.textRedlineOfTrackerCard)(card);
}
function summaryOf(group) {
  var edits = (0, _wordLikeParagraph.editMembersOf)(group).length + (0, _wordLikeParagraph.newParagraphMembersOf)(group).length;
  var comments = (0, _wordLikeParagraph.commentMembersOf)(group).length;
  var editNoun = group.kind === "table" ? "table change" : "edit";
  var parts = [edits > 0 ? "".concat(edits, " ").concat(editNoun).concat(edits === 1 ? "" : "s") : null, comments > 0 ? "".concat(comments, " ").concat(comments === 1 ? "comment" : "comments") : null];
  return parts.filter(function (part) {
    return part !== null;
  }).join(" · ");
}
function segmentStyleOf(kind, color) {
  return _objectSpread({
    color: color
  }, kind === "deleted" ? {
    textDecoration: "line-through"
  } : _revisionStyle.INSERTION_UNDERLINE);
}
var WordLikeParagraphGroups = exports.WordLikeParagraphGroups = function WordLikeParagraphGroups(_ref6) {
  var _useProposalEngineAcc;
  var groups = _ref6.groups,
    pendingIds = _ref6.pendingIds,
    conversationId = _ref6.conversationId,
    renderGoToButton = _ref6.renderGoToButton,
    conflictSummariesOf = _ref6.conflictSummariesOf,
    onOpenResolver = _ref6.onOpenResolver,
    onShowCard = _ref6.onShowCard,
    onEditCard = _ref6.onEditCard,
    onDismiss = _ref6.onDismiss,
    onToggleSelection = _ref6.onToggleSelection,
    onApplyActions = _ref6.onApplyActions,
    tablePackagesByGroup = _ref6.tablePackagesByGroup;
  var pageAuthorColorOf = (0, _RedlineAuthorColorsContext.useRedlineAuthorColor)();
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _useState = (0, _react.useState)(new Set()),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredActionIds = _useState2[0],
    setHoveredActionIds = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    editingActionId = _useState4[0],
    setEditingActionId = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    editorActionsSlot = _useState6[0],
    setEditorActionsSlot = _useState6[1];
  var hoverTimersRef = (0, _react.useRef)(new Map());
  var _useProposalEdits = (0, _ProposalEditsContext.useProposalEdits)(),
    saveEdit = _useProposalEdits.saveEdit;
  var resetProposalEdit = (0, _useResetProposalEdit.useResetProposalEdit)(conversationId);
  var editAuthorName = (_useProposalEngineAcc = (0, _useProposalEngineEnabled.useProposalEngineAccess)().authorName) !== null && _useProposalEngineAcc !== void 0 ? _useProposalEngineAcc : _redlineEngine.DIOPTRA_AUTHOR;
  var tableCardColorsByGroup = (0, _react.useMemo)(function () {
    return new Map(groups.filter(function (group) {
      return group.kind === "table";
    }).map(function (group) {
      try {
        return [group.bookmark, (0, _tableGroupPackage.tableCardColorByAuthorOf)(group)];
      } catch (error) {
        sendError(asError(error), {
          component: "WordLikeParagraphGroups",
          action: "color_table_group",
          tableGroup: group.bookmark
        });
        return [group.bookmark, NO_TABLE_CARD_COLORS];
      }
    }));
  }, [groups, sendError]);
  var _useMemo = (0, _react.useMemo)(function () {
      var composed = new Map();
      var buildFailures = new Map();
      var groupFailures = new Map();
      var _iterator = _createForOfIteratorHelper(groups),
        _step;
      try {
        var _loop = function _loop() {
          var group = _step.value;
          var tablePackage = tablePackagesByGroup.get(group.bookmark);
          if (group.kind !== "table" || tablePackage === undefined) return 1; // continue
          var pendingTableEdits = (0, _wordLikeParagraph.editMembersOf)(group).filter(function (member) {
            return !member.action.isApplied;
          });
          var reportFailure = function reportFailure(error, action) {
            return sendError(asError(error), {
              component: "WordLikeParagraphGroups",
              action: action,
              tableGroup: group.bookmark
            });
          };
          try {
            var composedTable = _anchoredProposal.AnchoredProposal.composeChangesOverTable(tablePackage, (0, _tableGroupPackage.tableGroupChangesOf)(pendingTableEdits, DRAWER_COMPOSITION_STAMPED_AT), function (error, changeThatThrew) {
              reportFailure(error, "compose_table_group");
              buildFailures.set(changeThatThrew.actionId, _anchorLog.AnchorLog.messageOf(error));
            });
            composed.set(group.bookmark, composedTableWithCommentMarks(composedTable, commentedCellsOf(group), function (actionId, error) {
              reportFailure(error, "mark_table_comment");
              buildFailures.set(actionId, _anchorLog.AnchorLog.messageOf(error));
            }));
          } catch (error) {
            reportFailure(error, "compose_table_group");
            var reason = _anchorLog.AnchorLog.messageOf(error);
            groupFailures.set(group.bookmark, reason);
            pendingTableEdits.forEach(function (member) {
              return buildFailures.set(member.action.id, reason);
            });
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          if (_loop()) continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        composedTables: composed,
        tableBuildFailureByActionId: buildFailures,
        tableGroupFailureByBookmark: groupFailures
      };
    }, [groups, tablePackagesByGroup, sendError]),
    composedTables = _useMemo.composedTables,
    tableBuildFailureByActionId = _useMemo.tableBuildFailureByActionId,
    tableGroupFailureByBookmark = _useMemo.tableGroupFailureByBookmark;
  (0, _useFailedCardsNotShown.useFailedCardsNotShown)(tableBuildFailureByActionId, "table_groups");
  var heldBackReasonOf = function heldBackReasonOf(action) {
    var _action$heldBackReaso;
    return (_action$heldBackReaso = action.heldBackReason) !== null && _action$heldBackReaso !== void 0 ? _action$heldBackReaso : tableBuildFailureByActionId.get(action.id);
  };
  var isActive = function isActive(actionId) {
    return hoveredActionIds.has(actionId);
  };
  var hoverHandlers = function hoverHandlers(actionId) {
    return {
      onMouseEnter: function onMouseEnter() {
        var timer = window.setTimeout(function () {
          hoverTimersRef.current.delete(actionId);
          setHoveredActionIds(function (current) {
            return new Set(current).add(actionId);
          });
        }, HOVER_DELAY_MS);
        hoverTimersRef.current.set(actionId, timer);
      },
      onMouseLeave: function onMouseLeave() {
        var timer = hoverTimersRef.current.get(actionId);
        if (timer !== undefined) {
          window.clearTimeout(timer);
          hoverTimersRef.current.delete(actionId);
        }
        setHoveredActionIds(function (current) {
          if (!current.has(actionId)) return current;
          var next = new Set(current);
          next.delete(actionId);
          return next;
        });
      }
    };
  };
  var openInChat = function openInChat(actionId) {
    return function (event) {
      event.stopPropagation();
      onShowCard(actionId);
    };
  };
  function renderCheckbox(action) {
    var disabled = Boolean(action.isPartiallyApplied) || Boolean(action.documentAlreadyReadsAsProposed) || heldBackReasonOf(action) !== undefined;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, {
      checked: action.isSelected,
      onCheckedChange: function onCheckedChange() {
        return onToggleSelection(action.id);
      },
      "aria-label": "Select #".concat(action.cardNumber),
      disabled: disabled,
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      className: "size-3.5",
      "data-sentry-element": "Checkbox",
      "data-sentry-component": "renderCheckbox",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx"
    });
  }
  function selectableMembersOf(group) {
    return [].concat(_toConsumableArray((0, _wordLikeParagraph.editMembersOf)(group)), _toConsumableArray((0, _wordLikeParagraph.newParagraphMembersOf)(group)), _toConsumableArray((0, _wordLikeParagraph.commentMembersOf)(group).map(function (comment) {
      return comment.member;
    }))).filter(function (member) {
      return pendingIds.has(member.action.id) && !member.action.isPartiallyApplied && !member.action.documentAlreadyReadsAsProposed && heldBackReasonOf(member.action) === undefined;
    });
  }
  function renderGroupCheckbox(group) {
    var selectable = selectableMembersOf(group);
    if (selectable.length === 0) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
      width: 13,
      height: 13,
      className: "flex-shrink-0 text-[#10B981]"
    });
    var allSelected = selectable.every(function (member) {
      return member.action.isSelected;
    });
    var toggleAll = function toggleAll() {
      selectable.filter(function (member) {
        return member.action.isSelected === allSelected;
      }).forEach(function (member) {
        return onToggleSelection(member.action.id);
      });
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, {
      checked: allSelected,
      onCheckedChange: toggleAll,
      "aria-label": "Select every card in this paragraph",
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      className: "size-3.5",
      "data-sentry-element": "Checkbox",
      "data-sentry-component": "renderGroupCheckbox",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx"
    });
  }
  function renderApplyButton(group) {
    var selectedPendingIds = selectableMembersOf(group).filter(function (member) {
      return member.action.isSelected;
    }).map(function (member) {
      return member.action.id;
    });
    var isDisabled = selectedPendingIds.length === 0;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      type: "button",
      disabled: isDisabled,
      onClick: function onClick(event) {
        event.stopPropagation();
        onApplyActions(selectedPendingIds);
      },
      className: (0, _utils.cn)(headerButtonClass, "text-white bg-primary border-primary disabled:bg-[#B0B0B0] disabled:border-[#B0B0B0] disabled:cursor-not-allowed"),
      title: "Apply the selected cards of this paragraph",
      "data-sentry-component": "renderApplyButton",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [APPLY_PARAGRAPH_LABEL, selectedPendingIds.length > 0 ? " ".concat(selectedPendingIds.length) : ""]
    });
  }
  function renderMemberControls(group, member) {
    var action = member.action;
    var isPending = pendingIds.has(action.id);
    var isEditingHere = editingActionId === action.id;
    var canEditInline = isPending && (member.card.content.kind === "comment" || editableTextCardOf(member.card, editAuthorName) !== null);
    var canEditInChat = isPending && !canEditInline && group.kind !== "table";
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "flex items-center gap-0.5 flex-shrink-0",
      "data-sentry-component": "renderMemberControls",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [isEditingHere && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        ref: setEditorActionsSlot,
        className: "flex items-center gap-1"
      }), canEditInline && !isEditingHere && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: function onClick(event) {
          event.stopPropagation();
          setEditingActionId(action.id);
        },
        className: iconButtonClass,
        title: "Edit here",
        "aria-label": "Edit #".concat(action.cardNumber),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {
          width: 12,
          height: 12,
          className: iconClass
        })
      }), canEditInChat && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: function onClick(event) {
          event.stopPropagation();
          onEditCard(action.id);
        },
        className: iconButtonClass,
        title: "Edit in the chat",
        "aria-label": "Edit #".concat(action.cardNumber, " in the chat"),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {
          width: 12,
          height: 12,
          className: iconClass
        })
      }), isPending && !isEditingHere && (0, _trackerTypes.trackerCardHasUserEdit)(member.card) && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: function onClick(event) {
          event.stopPropagation();
          resetProposalEdit(action.id, (0, _cardKinds.proposalCardKindOfContent)(member.card.content), "drawer");
        },
        className: iconButtonClass,
        title: _ProposalCardActions.RESET_TO_AGENT_VERSION_LABEL,
        "aria-label": "".concat(_ProposalCardActions.RESET_TO_AGENT_VERSION_LABEL, " (#").concat(action.cardNumber, ")"),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UndoIcon, {
          width: 12,
          height: 12,
          className: iconClass
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: openInChat(action.id),
        className: iconButtonClass,
        title: OPEN_IN_CHAT_TITLE,
        "aria-label": OPEN_IN_CHAT_TITLE,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.OpenInNewIcon, {
          width: 12,
          height: 12,
          className: iconClass,
          "data-sentry-element": "OpenInNewIcon",
          "data-sentry-source-file": "WordLikeParagraphGroups.tsx"
        })
      }), isPending && !isEditingHere && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: function onClick(event) {
          event.stopPropagation();
          onDismiss(action.id);
        },
        disabled: action.isDismissalSaving,
        "aria-busy": action.isDismissalSaving || undefined,
        className: iconButtonClass,
        title: "Dismiss",
        "aria-label": "Dismiss #".concat(action.cardNumber),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyIconOrSpinner, {
          isSaving: Boolean(action.isDismissalSaving),
          icon: _materialSymbols.CloseIcon,
          size: 12,
          className: iconClass
        })
      })]
    });
  }
  function renderMemberStatus(action) {
    if (action.isApplied) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "flex items-center gap-0.5 text-[10px] font-medium text-[#166534]",
        title: writtenBackReasonOf(action),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
          width: 11,
          height: 11
        }), appliedStatusLabelOf(action)]
      });
    }
    if (action.isRefused) return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "flex items-center gap-0.5 text-[10px] font-medium text-[#A81E36]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
        width: 11,
        height: 11
      }), "Not applied"]
    });
    if (action.failureReason) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[10px] font-medium text-[#A81E36]",
      title: action.failureReason,
      children: "Failed"
    });
    if (action.rowRemovedBy) return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "flex items-center gap-0.5 text-[10px] font-medium text-[#92400E]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
        width: 11,
        height: 11
      }), (0, _redlineRowRemoved.rowRemovedLabelOf)(action.rowRemovedBy)]
    });
    var heldBackReason = heldBackReasonOf(action);
    if (heldBackReason) return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "flex items-center gap-0.5 text-[10px] font-medium text-[#92400E]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
        width: 11,
        height: 11
      }), heldBackReason]
    });
    return null;
  }
  function renderMarked(children, commentIds, comments, key, trailingText, bracketMode) {
    var _covering$find, _covering$;
    var covering = comments.filter(function (comment) {
      return commentIds.includes(comment.member.action.id);
    });
    var active = (_covering$find = covering.find(function (comment) {
      return isActive(comment.member.action.id);
    })) !== null && _covering$find !== void 0 ? _covering$find : null;
    var shown = active !== null && active !== void 0 ? active : bracketMode ? null : (_covering$ = covering[0]) !== null && _covering$ !== void 0 ? _covering$ : null;
    if (shown === null) return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
      children: [children, trailingText]
    }, key);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("mark", _objectSpread(_objectSpread({
      className: "text-inherit cursor-pointer",
      style: {
        backgroundColor: active !== null ? shown.activeColor : shown.color
      },
      "data-comment-card": shown.member.action.cardNumber,
      onClick: openInChat(shown.member.action.id)
    }, hoverHandlers(shown.member.action.id)), {}, {
      "data-sentry-component": "renderMarked",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [children, trailingText]
    }), key);
  }
  function renderWordToken(token, comments, key, trailingText, bracketMode) {
    var word = token.pageInsertedBy === null ? token.text : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: segmentStyleOf("inserted", pageAuthorColorOf(token.pageInsertedBy)),
      title: "Inserted by ".concat(token.pageInsertedBy),
      children: token.text
    });
    return renderMarked(word, token.commentIds, comments, key, trailingText, bracketMode);
  }
  function renderPageDeletionToken(token, key, trailingText) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: segmentStyleOf("deleted", pageAuthorColorOf(token.author)),
        title: "Deleted by ".concat(token.author),
        children: token.text
      }), trailingText]
    }, key);
  }
  function renderChangeToken(token, comments, changeColors, key, trailingText, bracketMode) {
    var _changeColors$get;
    var color = (_changeColors$get = changeColors.get(token.actionId)) !== null && _changeColors$get !== void 0 ? _changeColors$get : "var(--primary)";
    var lastSegmentIndex = token.segments.length - 1;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
      role: "button",
      tabIndex: 0,
      "data-change-card": token.cardNumber,
      className: (0, _utils.cn)("inline rounded-[2px] cursor-pointer", isActive(token.actionId) && "ring-1 ring-[#4a5568]"),
      title: "".concat(_cardKinds.PROPOSAL_CARD_KIND_LABELS.redline, " #").concat(token.cardNumber),
      onClick: openInChat(token.actionId),
      onKeyDown: activateOnEnterOrSpace(function () {
        return onShowCard(token.actionId);
      })
    }, hoverHandlers(token.actionId)), {}, {
      "data-sentry-component": "renderChangeToken",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: token.segments.map(function (segment, position) {
        return renderMarked(/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: segmentStyleOf(segment.kind, color),
          children: segment.text
        }), token.commentIds, comments, "".concat(key, "-segment-").concat(position), position === lastSegmentIndex ? trailingText : "", bracketMode);
      })
    }), key);
  }
  function renderAlternative(alternative, comments, changeColors, commentIds, key, trailingText, bracketMode) {
    var _changeColors$get2;
    var firstCard = alternative.cards[0];
    var color = (_changeColors$get2 = changeColors.get(firstCard.actionId)) !== null && _changeColors$get2 !== void 0 ? _changeColors$get2 : "var(--primary)";
    var alternativeIsActive = alternative.cards.some(function (card) {
      return isActive(card.actionId);
    });
    var insertedSpan = alternative.insertedText.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[#9A9896] italic",
      children: "remove"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: segmentStyleOf("inserted", color),
      children: alternative.insertedText
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
      role: "button",
      tabIndex: 0,
      "data-change-card": firstCard.cardNumber,
      className: (0, _utils.cn)("inline rounded-[2px] cursor-pointer", alternativeIsActive && "ring-1 ring-[#4a5568]"),
      title: alternative.cards.map(function (card) {
        return "".concat(_cardKinds.PROPOSAL_CARD_KIND_LABELS.redline, " #").concat(card.cardNumber);
      }).join(", "),
      onClick: openInChat(firstCard.actionId),
      onKeyDown: activateOnEnterOrSpace(function () {
        return onShowCard(firstCard.actionId);
      })
    }, hoverHandlers(firstCard.actionId)), {}, {
      "data-sentry-component": "renderAlternative",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: renderMarked(insertedSpan, commentIds, comments, "".concat(key, "-inserted"), trailingText, bracketMode)
    }), key);
  }
  function renderConflictToken(token, comments, changeColors, key, trailingText, bracketMode) {
    var deletedSpan = token.deletedText.length === 0 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: deletedTextClass,
      children: token.deletedText
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      "data-conflict": token.contested ? "true" : undefined,
      className: (0, _utils.cn)("inline rounded-[3px] px-0.5", token.contested && "outline-dashed outline-1 outline-[#F59E0B]"),
      title: token.contested ? "These redlines change the same words differently" : undefined,
      "data-sentry-component": "renderConflictToken",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [deletedSpan !== null && renderMarked(deletedSpan, token.commentIds, comments, "".concat(key, "-deleted"), "", bracketMode), token.alternatives.map(function (alternative, position) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
          children: [position > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "text-[#9A9896]",
            children: " / "
          }), renderAlternative(alternative, comments, changeColors, token.commentIds, "".concat(key, "-alternative-").concat(position, "-text"), position === token.alternatives.length - 1 ? trailingText : "", bracketMode)]
        }, "".concat(key, "-alternative-").concat(position));
      })]
    }, key);
  }
  function renderToken(token, comments, changeColors, key, trailingText, bracketMode) {
    if (token.kind === "word") return renderWordToken(token, comments, key, trailingText, bracketMode);
    if (token.kind === "pageDeleted") return renderPageDeletionToken(token, key, trailingText);
    if (token.kind === "change") return renderChangeToken(token, comments, changeColors, key, trailingText, bracketMode);
    return renderConflictToken(token, comments, changeColors, key, trailingText, bracketMode);
  }
  function renderBracket(comment, glyph, key) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
      className: (0, _utils.cn)("font-semibold cursor-pointer", isActive(comment.member.action.id) ? "opacity-100" : "opacity-80"),
      style: {
        color: comment.activeColor
      },
      "data-comment-bracket": comment.member.action.cardNumber,
      title: "".concat(_cardKinds.PROPOSAL_CARD_KIND_LABELS.comment, " #").concat(comment.member.action.cardNumber),
      onClick: openInChat(comment.member.action.id)
    }, hoverHandlers(comment.member.action.id)), {}, {
      "data-sentry-component": "renderBracket",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: glyph
    }), key);
  }
  function renderParagraph(group, comments, changeColors) {
    var tokens = (0, _wordLikeParagraph.wordLikeTokensOf)(group);
    var bracketMode = tokens.some(function (token) {
      return token.commentIds.length > 1;
    });
    var commentOf = function commentOf(commentId) {
      var _comments$find;
      return (_comments$find = comments.find(function (comment) {
        return comment.member.action.id === commentId;
      })) !== null && _comments$find !== void 0 ? _comments$find : null;
    };
    var bracketsFor = function bracketsFor(commentIds, glyph, key) {
      return commentIds.flatMap(function (commentId) {
        var comment = commentOf(commentId);
        return comment === null ? [] : [renderBracket(comment, glyph, "".concat(key, "-").concat(commentId))];
      });
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "m-0 text-[12px] leading-[19px] text-[#171715] break-words cursor-text",
      "data-comment-brackets": bracketMode ? "true" : undefined,
      "data-sentry-component": "renderParagraph",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: tokens.flatMap(function (token, position) {
        var previousToken = tokens[position - 1];
        var nextToken = tokens[position + 1];
        var sharesCommentWithNext = !bracketMode && nextToken !== undefined && token.commentIds.some(function (commentId) {
          return nextToken.commentIds.includes(commentId);
        });
        var key = "token-".concat(position);
        var opening = bracketMode ? token.commentIds.filter(function (commentId) {
          return previousToken === undefined || !previousToken.commentIds.includes(commentId);
        }) : [];
        var closing = bracketMode ? token.commentIds.filter(function (commentId) {
          return nextToken === undefined || !nextToken.commentIds.includes(commentId);
        }) : [];
        var rendered = renderToken(token, comments, changeColors, key, sharesCommentWithNext ? token.trailingText : "", bracketMode);
        var separator = !sharesCommentWithNext && token.trailingText.length > 0 ? [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.default.Fragment, {
          children: token.trailingText
        }, "space-".concat(position))] : [];
        return [].concat(_toConsumableArray(bracketsFor(opening, "⟦", "".concat(key, "-open"))), [rendered], _toConsumableArray(bracketsFor(closing, "⟧", "".concat(key, "-close"))), separator);
      })
    });
  }
  function renderTablePage(group, comments) {
    var _tableCardColorsByGro;
    var composedTable = composedTables.get(group.bookmark);
    var groupFailure = tableGroupFailureByBookmark.get(group.bookmark);
    var tableBody = composedTable === undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-[#9A9896]",
      children: "Reading the table\u2026"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(ComposedTablePage, {
      composedTable: composedTable,
      cardColorByAuthor: (_tableCardColorsByGro = tableCardColorsByGroup.get(group.bookmark)) !== null && _tableCardColorsByGro !== void 0 ? _tableCardColorsByGro : NO_TABLE_CARD_COLORS
    });
    var commentHighlightRules = comments.map(function (_ref7) {
      var member = _ref7.member,
        color = _ref7.color,
        activeColor = _ref7.activeColor;
      return "[data-word-like-table=\"".concat(group.bookmark, "\"] [data-comment-id~=\"").concat(member.action.cardNumber, "\"]{background:").concat(isActive(member.action.id) ? activeColor : color, ";border-radius:2px;}");
    }).join("");
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "rounded border bg-white px-3 py-2 text-[11px] leading-[16px] text-[#1f2937] shadow-[0_1px_2px_rgba(0,0,0,0.06)] cursor-text overflow-x-auto",
      style: {
        borderColor: "#E5E2DD"
      },
      "data-word-like-table": group.bookmark,
      "data-sentry-component": "renderTablePage",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [commentHighlightRules.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
        children: commentHighlightRules
      }), groupFailure === undefined ? tableBody : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[#92400E]",
        title: groupFailure,
        children: TABLE_NOT_DRAWN_LABEL
      })]
    });
  }
  function renderPageRevisionsLegend(group) {
    var authors = (0, _pageRevisions.pageAuthorsOf)(group.pageRevisions);
    if (authors.length === 0) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[10px] text-[#686766]",
      "data-page-revisions-legend": true,
      "data-sentry-component": "renderPageRevisionsLegend",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        children: [PAGE_REVISIONS_LEGEND_LABEL, ":"]
      }), authors.map(function (author) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "flex items-center gap-1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "inline-block w-2 h-2 rounded-sm",
            style: {
              backgroundColor: pageAuthorColorOf(author)
            }
          }), author]
        }, author);
      })]
    });
  }
  function renderNewParagraph(member, changeColors) {
    var _changeColors$get3;
    var texts = newParagraphTextsOf(member);
    if (texts.length === 0) return null;
    var color = (_changeColors$get3 = changeColors.get(member.action.id)) !== null && _changeColors$get3 !== void 0 ? _changeColors$get3 : "var(--primary)";
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
      role: "button",
      tabIndex: 0,
      "data-new-paragraph-card": member.action.cardNumber,
      className: (0, _utils.cn)("flex flex-col gap-0.5 cursor-pointer rounded-[2px]", isActive(member.action.id) && "ring-1 ring-[#4a5568]"),
      title: "".concat(_cardKinds.PROPOSAL_CARD_KIND_LABELS.paragraph, " #").concat(member.action.cardNumber),
      onClick: openInChat(member.action.id),
      onKeyDown: activateOnEnterOrSpace(function () {
        return onShowCard(member.action.id);
      })
    }, hoverHandlers(member.action.id)), {}, {
      "data-sentry-component": "renderNewParagraph",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: texts.map(function (text, position) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "m-0 text-[12px] leading-[19px] break-words",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: segmentStyleOf("inserted", color),
            children: text
          })
        }, position);
      })
    }), member.action.id);
  }
  function renderPage(group, comments, changeColors) {
    var _wholeParagraphCommen, _wholeParagraphCommen2;
    var newParagraphs = (0, _wordLikeParagraph.newParagraphMembersOf)(group).filter(function (member) {
      return !member.action.isApplied;
    });
    var wholeParagraphComments = comments.filter(function (comment) {
      return comment.member.wordSpan === null;
    });
    var pageBorderColor = (_wholeParagraphCommen = (_wholeParagraphCommen2 = wholeParagraphComments[0]) === null || _wholeParagraphCommen2 === void 0 ? void 0 : _wholeParagraphCommen2.color) !== null && _wholeParagraphCommen !== void 0 ? _wholeParagraphCommen : "#D4D3D0";
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-1.5 rounded border bg-white px-3 py-2 shadow-[0_1px_2px_rgba(0,0,0,0.06)] cursor-text",
      style: {
        borderColor: "#E5E2DD",
        borderLeftWidth: 3,
        borderLeftColor: pageBorderColor
      },
      "data-word-like-page": group.bookmark,
      "data-sentry-component": "renderPage",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [renderPageRevisionsLegend(group), group.baseText.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "m-0 text-[11px] italic text-[#9A9896]",
        children: "The paragraph text is not available for this group."
      }) : renderParagraph(group, comments, changeColors), newParagraphs.map(function (member) {
        return renderNewParagraph(member, changeColors);
      })]
    });
  }
  function renderCommentEditor(member, text) {
    var textBeforeEdit = member.card.textBeforeEdit;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      "data-sentry-component": "renderCommentEditor",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentTextEditor.CommentTextEditor, {
        text: text,
        textBeforeEdit: textBeforeEdit,
        kindLabel: "comment",
        actionsSlot: editorActionsSlot,
        onSave: function onSave(edited) {
          saveEdit(conversationId, member.action.id, {
            kind: "comment",
            textBeforeEdit: textBeforeEdit !== null && textBeforeEdit !== void 0 ? textBeforeEdit : text,
            text: edited
          });
          setEditingActionId(null);
        },
        onCancel: function onCancel() {
          return setEditingActionId(null);
        },
        "data-sentry-element": "CommentTextEditor",
        "data-sentry-source-file": "WordLikeParagraphGroups.tsx"
      })
    });
  }
  function proposalPackageFromPage(group, textRedline) {
    var paragraphPackage = group.kind === "paragraph" ? tablePackagesByGroup.get((0, _pageRevisions.tableGroupKeyOf)(group.bookmark)) : undefined;
    if (paragraphPackage === undefined) return null;
    try {
      return new _anchoredProposal.AnchoredProposal((0, _redlinePayload.textsPayloadFrom)(textRedline), "asTrackedChange").buildOverPackage({
        rangeOoxml: paragraphPackage,
        placement: _redlinePlacement.ON_PARAGRAPH,
        stampedAt: DRAWER_COMPOSITION_STAMPED_AT
      }).outcome.packageOoxml;
    } catch (_unused2) {
      return null;
    }
  }
  function renderRedlineEditor(group, member, textRedline) {
    var textRedlineBeforeEdit = member.card.textRedlineBeforeEdit;
    var textRedlineWhenOpened = member.card.textRedlineWhenOpened;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "rounded border border-[#E5E2DD] bg-white px-2 py-1.5",
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      "data-sentry-component": "renderRedlineEditor",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProposalEditorOnPage.ProposalEditorOnPage, {
        textRedline: textRedline,
        textRedlineBeforeEdit: textRedlineBeforeEdit,
        textRedlineWhenOpened: textRedlineWhenOpened,
        author: editAuthorName,
        proposalPackageOoxml: proposalPackageFromPage(group, textRedlineBeforeEdit !== null && textRedlineBeforeEdit !== void 0 ? textRedlineBeforeEdit : textRedline),
        proposalStampedAt: DRAWER_COMPOSITION_STAMPED_AT,
        actionsSlot: editorActionsSlot,
        onSave: function onSave(edited, textRedlineTheBoxOpenedOn) {
          saveEdit(conversationId, member.action.id, {
            kind: "redline",
            textRedlineBeforeEdit: textRedlineBeforeEdit !== null && textRedlineBeforeEdit !== void 0 ? textRedlineBeforeEdit : textRedline,
            textRedline: edited,
            textRedlineWhenOpened: textRedlineTheBoxOpenedOn
          });
          setEditingActionId(null);
        },
        onCancel: function onCancel() {
          return setEditingActionId(null);
        },
        "data-sentry-element": "ProposalEditorOnPage",
        "data-sentry-source-file": "WordLikeParagraphGroups.tsx"
      })
    });
  }
  function renderCommentBalloon(group, comment) {
    var member = comment.member,
      color = comment.color;
    var text = member.card.content.kind === "comment" ? member.card.content.text : "";
    var isEditing = editingActionId === member.action.id;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-comment-balloon": member.action.cardNumber,
      className: (0, _utils.cn)("flex items-start gap-1.5 rounded border bg-white px-1.5 py-1 cursor-default", isActive(member.action.id) ? "border-[#4a5568]" : "border-[#E5E2DD]"),
      style: {
        borderLeftWidth: 3,
        borderLeftColor: color
      },
      "data-sentry-component": "renderCommentBalloon",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [pendingIds.has(member.action.id) ? renderCheckbox(member.action) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
        width: 12,
        height: 12,
        className: "flex-shrink-0 mt-0.5 text-[#10B981]"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
        className: "flex-1 min-w-0 flex flex-col gap-0.5 cursor-pointer",
        onClick: openInChat(member.action.id)
      }, hoverHandlers(member.action.id)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex items-center gap-1 text-[10px] text-[#686766]",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "font-semibold text-[#4a5568]",
            children: [_cardKinds.PROPOSAL_CARD_KIND_LABELS.comment, " #", member.action.cardNumber]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "truncate",
            children: ["on ", anchorLabelOf(group, member)]
          }), renderMemberStatus(member.action)]
        }), isEditing ? renderCommentEditor(member, text) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "text-[11px] leading-[15px] text-[#171715] whitespace-pre-wrap",
          children: (0, _textExcerpt.excerptOf)(text, COMMENT_EXCERPT_CHARACTERS)
        })]
      })), renderMemberControls(group, member)]
    }, member.action.id);
  }
  function renderChangeRow(group, member, comments, changeColors) {
    var _changeColors$get4;
    var action = member.action,
      card = member.card;
    var isEditing = editingActionId === action.id;
    var editableTextCard = isEditing ? editableTextCardOf(card, editAuthorName) : null;
    var color = (_changeColors$get4 = changeColors.get(action.id)) !== null && _changeColors$get4 !== void 0 ? _changeColors$get4 : "var(--primary)";
    var attachedComments = comments.filter(function (comment) {
      return member.attachedComments.some(function (attached) {
        return attached.action.id === comment.member.action.id;
      });
    });
    var summary = (0, _paragraphGroups.changeSummaryOf)(group, member);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-1",
      "data-sentry-component": "renderChangeRow",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-edit-row": action.cardNumber,
        className: (0, _utils.cn)("flex items-center gap-1.5 rounded px-1.5 h-[22px] cursor-default", isActive(action.id) && "bg-[#EEF2FF]"),
        children: [pendingIds.has(action.id) ? renderCheckbox(action) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
          width: 12,
          height: 12,
          className: "flex-shrink-0 text-[#10B981]"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", _objectSpread(_objectSpread({
          className: "flex-shrink-0 text-[11px] font-semibold cursor-pointer",
          style: {
            color: color
          },
          onClick: openInChat(action.id)
        }, hoverHandlers(action.id)), {}, {
          children: [_cardKinds.PROPOSAL_CARD_KIND_LABELS[group.kind === "table" && card.content.kind === "redline" ? "table" : (0, _cardKinds.proposalCardKindOfContent)(card.content)], " #", action.cardNumber]
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
          className: "flex-shrink-0 max-w-[60%] truncate text-[10px] text-[#686766] cursor-pointer",
          title: summary,
          onClick: openInChat(action.id)
        }, hoverHandlers(action.id)), {}, {
          children: summary
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "flex-1"
        }), renderMemberStatus(action), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinksNeedingAddressIndicator.LinksNeedingAddressIndicator, {
          linksNeedingAddress: (0, _LinksNeedingAddressIndicator.linksNeedingAddressOf)((0, _trackerTypes.textRedlineOfTrackerCard)(card)),
          density: "drawerMember",
          "data-sentry-element": "LinksNeedingAddressIndicator",
          "data-sentry-source-file": "WordLikeParagraphGroups.tsx"
        }), renderMemberControls(group, member)]
      }), editableTextCard !== null && renderRedlineEditor(group, member, editableTextCard), attachedComments.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ml-5 flex flex-col gap-1",
        children: attachedComments.map(function (comment) {
          return renderCommentBalloon(group, comment);
        })
      })]
    }, action.id);
  }
  function renderGroup(group) {
    var conflict = group.conflict;
    var comments = (0, _wordLikeParagraph.commentMembersOf)(group);
    var changeColors = group.kind === "table" ? (0, _tableGroupPackage.tableChangeColorsOf)(group) : (0, _wordLikeParagraph.changeColorsOf)(group);
    var changeMembers = [].concat(_toConsumableArray((0, _wordLikeParagraph.editMembersOf)(group)), _toConsumableArray((0, _wordLikeParagraph.newParagraphMembersOf)(group))).sort(function (left, right) {
      return left.action.cardNumber - right.action.cardNumber;
    });
    var topLevelComments = comments.filter(function (comment) {
      return group.members.some(function (member) {
        return member.action.id === comment.member.action.id && (0, _wordLikeParagraph.isCommentMember)(member);
      });
    });
    var memberIds = (0, _paragraphGroups.memberActionIdsOf)(group);
    var hasAppliedCard = memberIds.some(function (actionId) {
      return !pendingIds.has(actionId);
    });
    var isUrgent = conflict !== null && !hasAppliedCard;
    var linkNeedingAddressSentences = changeMembers.flatMap(function (member) {
      return (0, _LinksNeedingAddressIndicator.linksNeedingAddressOf)((0, _trackerTypes.textRedlineOfTrackerCard)(member.card)).map(function (linkNeedingAddress) {
        return "#".concat(member.action.cardNumber, " \xB7 ").concat((0, _LinksNeedingAddressIndicator.linkNeedingAddressSentenceOf)(linkNeedingAddress));
      });
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _utils.cn)("flex flex-col gap-1.5 p-1.5 rounded border", isUrgent ? "border-[#FDE68A] bg-[#FFFDF5]" : "border-[#E5E2DD] bg-[#F8F6F3]"),
      "data-word-like-group": group.bookmark,
      "data-sentry-component": "renderGroup",
      "data-sentry-source-file": "WordLikeParagraphGroups.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-1.5",
        children: [renderGroupCheckbox(group), conflict !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
          width: 13,
          height: 13,
          className: "flex-shrink-0 text-[#F59E0B]"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _utils.cn)("flex-1 min-w-0 text-[11px] font-medium truncate", isUrgent ? "text-[#92400E]" : "text-[#4a5568]"),
          children: summaryOf(group)
        }), renderGoToButton((0, _paragraphGroups.pageBookmarksOf)(group), memberIds), renderApplyButton(group), conflict !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          type: "button",
          onClick: function onClick() {
            return onOpenResolver(conflict);
          },
          className: (0, _utils.cn)(headerButtonClass, "text-[#92400E] bg-white border-[#F59E0B]"),
          children: "Resolve"
        })]
      }), conflict !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: "list-none m-0 p-0 pl-5 flex flex-col",
        children: conflictSummariesOf(conflict).map(function (summary) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: (0, _utils.cn)("text-[11px]", isUrgent ? "text-[#B45309]" : "text-[#686766]"),
            children: summary
          }, summary);
        })
      }), linkNeedingAddressSentences.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: "list-none m-0 p-0 pl-5 flex flex-col",
        "data-testid": "group-links-needing-address",
        children: linkNeedingAddressSentences.map(function (sentence) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: "text-[11px] text-[#B45309]",
            children: sentence
          }, sentence);
        })
      }), group.kind === "table" ? renderTablePage(group, comments) : renderPage(group, comments, changeColors), topLevelComments.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col gap-1 pl-3",
        children: topLevelComments.map(function (comment) {
          return renderCommentBalloon(group, comment);
        })
      }), changeMembers.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex flex-col gap-1",
        children: changeMembers.map(function (member) {
          return renderChangeRow(group, member, comments, changeColors);
        })
      })]
    }, group.bookmark);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: groups.map(function (group) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionBoundary.SectionBoundary, {
        section: "apply_all_group",
        cardActionIds: (0, _paragraphGroups.memberActionIdsOf)(group),
        resetKeys: groupDrawKeysOf(group, tablePackagesByGroup),
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(GroupNotDrawn, {
          bookmark: group.bookmark
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DrawnByRender.DrawnByRender, {
          draw: function draw() {
            return renderGroup(group);
          }
        })
      }, group.bookmark);
    })
  });
};